import React, { useState, useEffect, useRef } from "react";
import "./InfoSection.css";
import heroImage from "../../assets/image-hero-1.png";
const accordionItems = [
  {
    icon: "fas fa-lightbulb",
    label: "What does Wealth Compounders do?",
    body: "Wealth Compounders is a financial services platform that helps investors access a wide range of investment products such as mutual funds, insurance, bonds, and other market-linked instruments through trusted and regulated partners.",
  },
  {
    icon: "fas fa-shield-alt",
    label: "Why choose Wealth Compounders?",
    body: "We focus on disciplined investing, long-term wealth creation, and seamless execution. Our platform simplifies investing while giving access to reliable financial products and structured solutions.",
  },
  {
    icon: "fas fa-users",
    label: "How can we help you in investment selection?",
    body: "We help investors understand different investment options, compare available products, and evaluate risk and return factors so they can make informed decisions based on their financial goals.",
  },
  {
    icon: "fas fa-bolt",
    label: "How can I start investing with Wealth Compounders?",
    body: "You can start by booking a free consultation, completing KYC, and selecting suitable investment products. Our team will assist you with the complete onboarding and execution process.",
  },
];

const words = [
  "Smart Investing Made Simple",
  "Access. Execute. Grow.",
  "Structured Investing for Long-Term Wealth",
];

const InfoSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [typedText, setTypedText] = useState("");
  const wordIndexRef = useRef(0);
  const letterIndexRef = useRef(0);
  const isDeletingRef = useRef(false);
  const revealRefs = useRef([]);

  useEffect(() => {
    let timeout;
    const typeLoop = () => {
      const word = words[wordIndexRef.current];
      const del = isDeletingRef.current;
      letterIndexRef.current = del
        ? letterIndexRef.current - 1
        : letterIndexRef.current + 1;
      setTypedText(word.substring(0, letterIndexRef.current));
      let speed = del ? 40 : 80;
      if (!del && letterIndexRef.current > word.length) {
        isDeletingRef.current = true;
        speed = 1500;
      } else if (del && letterIndexRef.current === 0) {
        isDeletingRef.current = false;
        wordIndexRef.current = (wordIndexRef.current + 1) % words.length;
        speed = 300;
      }
      timeout = setTimeout(typeLoop, speed);
    };
    timeout = setTimeout(typeLoop, 80);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          (e) => e.isIntersecting && e.target.classList.add("show"),
        ),
      { threshold: 0.1 },
    );
    revealRefs.current.forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section className="wc-ui-info-section" id="wc-ui-service">
      <div className="wc-ui-info-container">
        <div
          className="wc-ui-info-card wc-ui-info-feature-card wc-ui-reveal"
          ref={(el) => (revealRefs.current[0] = el)}
        >
          <h2 className="wc-ui-info-section-title">
            Frequently Asked Questions <br />
            <span className="wc-ui-gradient-text wc-ui-info-typing-text">
              {typedText}
            </span>
          </h2>
          <div className="wc-ui-accordion-wrapper">
            {accordionItems.map((item, i) => (
              <div
                key={i}
                className={`wc-ui-accordion-item${activeIndex === i ? " wc-ui-accordion-active" : ""}`}
              >
                <div
                  className="wc-ui-accordion-header"
                  onClick={() => setActiveIndex(activeIndex === i ? null : i)}
                >
                  <div className="wc-ui-accordion-icon-box">
                    <i className={item.icon}></i>
                  </div>
                  <span className="wc-ui-accordion-label">{item.label}</span>
                  <i className="fas fa-plus wc-ui-accordion-toggle-icon"></i>
                </div>
                <div className="wc-ui-accordion-body">
                  <p>{item.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="wc-ui-info-right-stack">
          <div
            className="wc-ui-info-card wc-ui-info-visual-card wc-ui-reveal"
            ref={(el) => (revealRefs.current[1] = el)}
          >
            <img
              src={heroImage}
              alt="Financial News"
              className="wc-ui-info-card-image"
            />
            <div className="wc-ui-info-overlay-gradient"></div>
            <div className="wc-ui-info-market-badge">
              <i className="fas fa-chart-line"></i>
              <span>Market Insights</span>
            </div>
          </div>

          <div
            className="wc-ui-info-card wc-ui-info-desc-card wc-ui-reveal"
            ref={(el) => (revealRefs.current[2] = el)}
          >
            <div>
              <h3 className="wc-ui-info-desc-title">
                Built for long-term wealth
              </h3>
              <p className="wc-ui-info-desc-subtitle">
                Smart strategies, clean execution, real compounding.
              </p>
            </div>
            <div className="wc-ui-info-desc-content">
              <p>
                At Wealth Compounders, we believe wealth is built through discipline, consistency, and informed decisions — not by chance.
              </p>
              <p>
                With a strong focus on execution, risk awareness, and long-term thinking, our platform enables you to move confidently toward your financial goals.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
